module.exports = "<div class=\"payment-page\">\n\n  <div class=\"logo-container\">\n    <img class=\"logo-premium\" src=\"/assets/img/premium-logo.png\" alt=\"Families Premium Logo\">\n  </div>\n\n  <div class=\"payment-text\">\n    Votre paiement a été effectué avec succès. <i class=\"fa fa-check\"></i>\n    <br/>\n    Votre compte a été mis à jour.\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/payment/success/payment-success.component.html
// module id = 269
// module chunks = 0